// client/src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import  jwtDecode  from 'jwt-decode'; // Use named import instead of default import
import authService from '../services/authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if token exists and is valid
    
    if (token) {
      try {
        const decoded = jwtDecode(token);
        
        // Check if token is expired
        if (decoded.exp * 1000 < Date.now()) {
          logout();
        } else {
          // Get user info
          authService.getCurrentUser(token)
            .then(data => {
              setUser(data.user);
            })
            .catch(() => {
              logout();
            })
            .finally(() => {
              setLoading(false);
            });
        }
      } catch (error) {
        logout();
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [token]);


  const login = async (credentials) => {
    try {
      console.log("Attempting login with:", credentials);
      const response = await authService.login(credentials);
      const data = response;
      
      console.log("Login response:", data);
      
      if (data.success && data.token) {
        localStorage.setItem('token', data.token);
        setToken(data.token);
        setUser(data.user);
        console.log("User set in context:", data.user);
        return { success: true };
      }
      
      return { 
        success: false, 
        message: data.message || 'Invalid credentials' 
      };
    } catch (error) {
      console.error("Login error in context:", error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Login failed' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  const isAdmin = () => {
    return user && user.role === 'admin';
  };

  const isFacultyUser = () => {
    return user && user.role === 'faculty';
  };

  const hasAccess = (requiredRole) => {
    if (!user) return false;
    if (requiredRole === 'admin') return user.role === 'admin';
    return true; // Both admin and faculty can access 'faculty' routes
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      login, 
      logout, 
      isAdmin, 
      isFacultyUser,
      hasAccess 
    }}>
      {children}
    </AuthContext.Provider>
  );
};